module.exports = __webpack_public_path__ + "static/fonts/Inter-Black.5f2ce7df.ttf";